import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.712 4.34a9 9 0 0 1 1.652 1.305c.51.51.944 1.064 1.306 1.652m-2.958-2.958-3.448 4.139m3.448-4.139a9.01 9.01 0 0 0-9.424 0M19.67 7.297l-4.138 3.449m4.138-3.45a9.01 9.01 0 0 1 0 9.426m-4.138-5.976a3.7 3.7 0 0 0-.88-1.388 3.7 3.7 0 0 0-1.388-.88m2.268 2.268a3.77 3.77 0 0 1 0 2.527m-2.268-4.795a3.77 3.77 0 0 0-2.528 0m4.796 4.795a3.75 3.75 0 0 1-.88 1.388 3.74 3.74 0 0 1-1.388.88m2.268-2.268 4.138 3.449m0 0a9 9 0 0 1-1.306 1.651c-.51.51-1.064.945-1.652 1.306m0 0-3.448-4.138m3.448 4.138a9.01 9.01 0 0 1-9.424 0m5.976-4.138a3.77 3.77 0 0 1-2.528 0m0 0a3.7 3.7 0 0 1-1.388-.88 3.7 3.7 0 0 1-.88-1.388m2.268 2.268-3.448 4.138m0 0a9 9 0 0 1-1.652-1.306 9 9 0 0 1-1.306-1.651m0 0 4.138-3.45m-4.138 3.45a9.01 9.01 0 0 1 0-9.425m4.138 5.976a3.77 3.77 0 0 1 0-2.527m0 0c.181-.507.475-.983.88-1.388.406-.406.882-.7 1.388-.88m-2.268 2.268L4.33 7.296m6.406 1.182L7.288 4.339m0 0a9 9 0 0 0-1.652 1.306A9 9 0 0 0 4.33 7.297"
    }, null, -1)
  ])))
}
export default { render: render }